module.exports = __webpack_public_path__ + "img/dropoff-pin.2963185d.svg";